import { render, staticRenderFns } from "./AdminReporting.vue?vue&type=template&id=c45fffd6"
import script from "./AdminReporting.vue?vue&type=script&lang=js"
export * from "./AdminReporting.vue?vue&type=script&lang=js"
import style0 from "./AdminReporting.vue?vue&type=style&index=0&id=c45fffd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports